<template>
  <div class="wrap" v-if="activate <= 11 || activate == 20">
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="search-page-wrap">
      <div class="data-table-title">プランのアップグレード(新規契約)</div>
      <!-- テーブルタイトル -->

      <div class="setting-wrap top upgrade">
        <div class="wrap-title">料金プラン</div>
        <div class="setting-upgrade-wrap top">
          <div class="setting-upgrade-title">料金プラン</div>
          <div class="setting-upgrade-content">
            <el-radio-group v-model="form.payment">
              
              <div v-show="findServicePlanByActivate(activate_starter)">
                <div class="setting-upgrade-plan-title">スタータープラン</div>
                <div class="setting-upgrade-plan-type" v-if="price.starter.month1">
                  <el-radio :label="100" border style="min-width:280px">1ヶ月契約：{{ price.starter.month1 | addComma }}円/月(税別)</el-radio>
                </div>
                <div class="setting-upgrade-plan-type" v-if="price.starter.month3">
                  <el-radio :label="101" border style="min-width:280px">3ヶ月契約：{{ price.starter.month3 | addComma }}円/月(税別)</el-radio>
                </div>              
                <div class="setting-upgrade-plan-type">
                  <el-radio :label="10" border style="min-width:280px">
                    6ヶ月契約：{{ price.starter.month6 | addComma }}円/月(税別)
                  </el-radio>
                </div>
                <div class="setting-upgrade-plan-type">
                  <el-radio :label="11" border style="min-width:280px">
                    12ヶ月契約：{{ price.starter.month12 | addComma }}円/月(税別)
                  </el-radio>
                </div>
                <div style="height:30px"></div>
              </div>

              <div v-show="findServicePlanByActivate(activate_manager)">
                <div class="setting-upgrade-plan-title">マネージャープラン</div>
                <div class="setting-upgrade-plan-type" v-if="price.manager.month1">
                  <el-radio :label="0" border style="min-width:280px">1ヶ月契約：{{ price.manager.month1 | addComma }}円/月(税別)</el-radio>
                </div>
                <div class="setting-upgrade-plan-type" v-if="price.manager.month3">
                  <el-radio :label="1" border style="min-width:280px">3ヶ月契約：{{ price.manager.month3 | addComma }}円/月(税別)</el-radio>
                </div>
                <div class="setting-upgrade-plan-type">
                  <el-radio :label="2" border style="min-width:280px"
                      >6ヶ月契約：{{ price.manager.month6 | addComma }}円/月(税別)
                    <div class="setting-upgrade-plan-promotion" v-show="price.manager.month6 != 125000">プロモーション価格</div>
                  </el-radio>
                </div>
                <div class="setting-upgrade-plan-type">
                  <div class="setting-upgrade-plan-tab" :style="form.payment != 3 ? 'opacity:0.5' : ''">オススメ</div>
                  <el-radio :label="3" border style="min-width:280px"
                      >12ヶ月契約：{{ price.manager.month12 | addComma }}円/月(税別)
                    <div class="setting-upgrade-plan-promotion" v-show="price.manager.month12 != 100000">プロモーション価格</div>
                  </el-radio>
                </div>
                <div style="height:30px"></div>
              </div>
            
              <div v-show="findServicePlanByActivate(activate_partner)">
                <div class="setting-upgrade-plan-title">パートナープラン</div>
                <div class="setting-upgrade-plan-type" v-if="price.partner.month1">
                  <el-radio :label="140" border style="min-width:280px">1ヶ月契約：{{ price.partner.month1 | addComma }}円/月(税別)</el-radio>
                </div>
                <div class="setting-upgrade-plan-type" v-if="price.partner.month3">
                  <el-radio :label="141" border style="min-width:280px">3ヶ月契約：{{ price.partner.month3 | addComma }}円/月(税別)</el-radio>
                </div>              
                <div class="setting-upgrade-plan-type">
                  <el-radio :label="142" border style="min-width:280px">
                    6ヶ月契約：{{ price.partner.month6 | addComma }}円/月(税別)
                  </el-radio>
                </div>
                <div class="setting-upgrade-plan-type">
                  <div class="setting-upgrade-plan-tab" :style="form.payment != 3 ? 'opacity:0.5' : ''">オススメ</div>
                  <el-radio :label="143" border style="min-width:280px">
                    12ヶ月契約：{{ price.partner.month12 | addComma }}円/月(税別)
                  </el-radio>
                </div>
                <div style="height:30px"></div>
              </div>

              <div v-show="findServicePlanByActivate(activate_pro)">
                <div class="setting-upgrade-plan-title">プロプラン</div>
                <div class="setting-upgrade-plan-type" v-if="price.pro.month1">
                  <el-radio :label="7" border style="min-width:280px">1ヶ月契約：{{ price.pro.month1 | addComma }}円/月(税別)</el-radio>
                </div>
                <div class="setting-upgrade-plan-type" v-if="price.pro.month3" style="margin-bottom:20px">
                  <el-radio :label="4" border style="min-width:280px">3ヶ月契約：{{ price.pro.month3 | addComma }}円/月(税別)</el-radio>
                </div>
                <div class="setting-upgrade-plan-type">
                  <el-radio :label="5" border style="min-width:280px">
                    6ヶ月契約：{{ price.pro.month6 | addComma }}円/月(税別)
                    <div class="setting-upgrade-plan-promotion" v-show="price.pro.month6 != 350000">プロモーション価格</div>
                  </el-radio>
                </div>
                <div class="setting-upgrade-plan-type">
                  <div class="setting-upgrade-plan-tab" :style="form.payment != 6 ? 'opacity:0.5' : ''">オススメ</div>
                  <el-radio :label="6" border style="min-width:280px">
                    12ヶ月契約：{{ price.pro.month12 | addComma }}円/月(税別)
                    <div class="setting-upgrade-plan-promotion" v-show="price.pro.month12 != 300000">プロモーション価格</div>
                  </el-radio>
                </div>
                <div style="height:30px"></div>
              </div>

              <div v-show="findServicePlanByActivate(activate_enterprise)">
                <div class="setting-upgrade-plan-title">エンタープライズプラン</div>
                <div class="setting-upgrade-plan-type">
                  <el-radio :label="8" border style="min-width:280px"> 12ヶ月契約：{{ price.enterprise.month12 | addComma }}円/月(税別) </el-radio>
                </div>
                <div class="setting-upgrade-plan-type">
                  <el-radio :label="9" border style="min-width:280px"> 24ヶ月契約：{{ price.enterprise.month24 | addComma }}円/月(税別) </el-radio>
                </div>
              </div>
              
            </el-radio-group>
          </div>
          <div>
            <div class="setting-upgrade-detail">
              <div class="setting-upgrade-plan-title"><font-awesome-icon icon="paper-plane" style="font-size:20px; margin-right:10px;" />プランの説明</div>
              <ul>
                <div class="divider-nomargin setting"></div>
                <li style="display:flex; flex-flow:row; justify-content:space-between">
                  <div>料金:</div>
                  <div>
                    <span style="font-weight:700; font-size:14px">{{ contract_price | addComma }}</span
                    >円/月(税別)
                  </div>
                </li>
                <li v-if="coupon_on" style="display:flex; flex-flow:row; justify-content:space-between">
                  <div class="flex-space"></div>
                  <span style="color:#0095f6; font-size:11px">プロモーション価格が適用されています</span>
                </li>
                <div class="divider-nomargin setting"></div>
                <li style="display:flex; flex-flow:row; justify-content:space-between">
                  <div>契約期間:</div>
                  <div>
                    <span style="font-weight:700; font-size:14px">{{ contract_period }}</span
                    >ヶ月
                    <span>&nbsp;({{ period_start }}〜{{ period_end }})</span>
                  </div>
                </li>
                <div class="divider-nomargin setting"></div>
                <li class="setting-upgrade-detail-item"><i class="el-icon-check setting-upgrade-icon"></i>インフルエンサー検索の<span v-if="selected_plan.search_influencer_youtube_enabled">全</span><span v-else>一部</span>機能</li>
                <li class="setting-upgrade-detail-item"><i class="el-icon-check setting-upgrade-icon"></i><span v-if="selected_plan.view_influencer_audience_enabled">フォロワー男女比、</span>関連エリア、視聴率、平均視聴回数、平均投稿頻度などの詳細データの閲覧</li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.search_post_enabled"><i class="el-icon-check setting-upgrade-icon"></i>投稿検索の全機能</li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.search_post_enabled"><i class="el-icon-check setting-upgrade-icon"></i>PR投稿検索</li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.create_influencer_list_limit_num > 30"><i class="el-icon-check setting-upgrade-icon"></i>インフルエンサーリスト機能(制限なし)</li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.create_influencer_list_limit_num <= 30">
                  <i class="el-icon-check setting-upgrade-icon"></i>インフルエンサーリスト機能
                  <br />
                  <span style="font-size:10px">(リスト上限{{ selected_plan.create_influencer_list_limit_num }}件)</span>
                </li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.export_influencer_list_enabled"><i class="el-icon-check setting-upgrade-icon"></i>リストエクスポート・ダウンロード機能</li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.create_report_limit_num > 30"><i class="el-icon-check setting-upgrade-icon"></i>レポート作成機能(制限なし)</li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.create_report_limit_num <= 30">
                  <i class="el-icon-check setting-upgrade-icon"></i>レポート作成機能
                  <br />
                  <span style="font-size:10px">(レポート上限{{ selected_plan.create_report_limit_num }}件)</span>
                </li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.view_dm_enabled">
                  <i class="el-icon-check setting-upgrade-icon"></i>ダイレクトメッセージ機能
                  <br />
                  <span style="font-size:10px">(Instagramアカウント連携上限 {{ selected_plan.connect_ig_account_limit_num }} 件)</span>
                </li>
                <li class="setting-upgrade-detail-item" v-if="!selected_plan.multi_access_enabled">
                  <i class="el-icon-warning-outline setting-upgrade-icon"></i>アクセス制限:&nbsp;1ユーザーのみ同時アクセス可能
                  <br />
                  <span style="font-size:10px">(複数ユーザーのアクセス・他部署へのアカウント共有不可)</span>
                </li>
                <li class="setting-upgrade-detail-item" v-else>
                  <i class="el-icon-check setting-upgrade-icon"></i>アクセス制限:&nbsp;無制限
                  <br />
                  <span style="margin-left:20px;font-size:10px">(同一部署内のみアカウント共有・同時アクセス可能)</span>
                </li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.manage_member_limit_num > 1">
                  <i class="el-icon-check setting-upgrade-icon"></i>サブアカウント作成
                  <br />
                  <span style="margin-left:20px;font-size:10px">(部署所属人数を上限として作成可能)</span>
                </li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.manage_brand_enabled"><i class="el-icon-check setting-upgrade-icon"></i>メンバー・ブランド管理機能</li>
                <li class="setting-upgrade-detail-item" v-if="selected_plan.service_plan_id > 0"><i class="el-icon-check setting-upgrade-icon"></i>追加機能リクエスト</li>
                <li class="setting-upgrade-detail-item" v-if="form.payment >= 10"><i class="el-icon-check setting-upgrade-icon"></i>チャットサポート</li>
                <li class="setting-upgrade-detail-item" v-else-if="form.payment >= 4"><i class="el-icon-check setting-upgrade-icon"></i>メール/電話/チャットサポート</li>
                <li class="setting-upgrade-detail-item" v-else><i class="el-icon-check setting-upgrade-icon"></i>メール/チャットサポート</li>
              </ul>
            </div>
            <div style="margin-top: 10px; font-size:11px">
              <div @click="coupon_modal = true" class="router-link">プロモーションコードを入力</div>
            </div>
          </div>
        </div>
      </div>

      <div class="setting-wrap upgrade">
        <div class="wrap-title">お支払い方法</div>
        <div class="setting-upgrade-wrap top">
          <div class="setting-upgrade-title">お支払い方法</div>
          <div class="setting-upgrade-content">
            <el-radio-group v-model="form.payment_method">
              <div class="setting-upgrade-plan-type">
                <el-radio :label="1" border style="min-width:280px">請求書払い(毎月)</el-radio>
              </div>
              <!-- <div class="setting-upgrade-plan-type">
                <el-radio :label="2" border style="min-width:280px">請求書払い(一括)</el-radio>
              </div>-->
            </el-radio-group>
          </div>
          <div>
            <div class="setting-upgrade-detail">
              <div class="setting-upgrade-plan-title">
                <font-awesome-icon icon="receipt" style="font-size:20px; margin-right:10px;" />
                {{ form.payment_method == "1" ? "毎月支払い" : "一括支払い" }}
              </div>
              <div class="divider-nomargin setting"></div>
              <div style="font-weight:700; margin-bottom:10px; color:#666" v-if="form.payment_method == '1'">毎月月末に1ヶ月分の利用料金をお支払いいただきます。</div>
              請求書は取引月に、メールにてお送りいたします。 <br />支払いは、請求書記載の口座宛に取引月の翌月末までにお振込みをお願いいたします。 <br />※
              見積書の発行、請求書の郵送等が必要な場合は別途お申し付けください。 <br />※ 領収証の発行は承っておりません。
              <br />
            </div>
          </div>
        </div>
      </div>

      <el-form :model="form" :rules="rules_upgrade" ref="form" @submit.native.prevent="apply">
        <div class="setting-wrap upgrade">
          <div class="wrap-title" style="width:100%; display:flex; flex-flow:row; justify-content:space-between">
            <div>請求先情報</div>
            <el-button type="default" @click="loadUserDataCopy">会社情報を貼り付け</el-button>
          </div>
          <div></div>
          <div class="setting-upgrade-wrap top">
            <div class="setting-upgrade-title">会社名<span style="color:red">*</span></div>
            <div class="setting-upgrade-content">
              <el-form-item prop="client_name"><el-input v-model="form.client_name"></el-input> </el-form-item>
            </div>
          </div>
          <div class="setting-upgrade-wrap">
            <div class="setting-upgrade-title">担当部署<span style="color:red">*</span></div>
            <div class="setting-upgrade-content">
              <el-form-item prop="department"><el-input v-model="form.department"></el-input> </el-form-item>
            </div>
          </div>
          <div class="setting-upgrade-wrap">
            <div class="setting-upgrade-title">担当者名<span style="color:red">*</span></div>
            <div class="setting-upgrade-content">
              <el-form-item prop="person_name"><el-input v-model="form.person_name"></el-input> </el-form-item>
            </div>
          </div>
          <div class="setting-upgrade-wrap">
            <div class="setting-upgrade-title">電話番号<span style="color:red">*</span></div>
            <div class="setting-upgrade-content">
              <el-form-item prop="tel"><el-input v-model="form.tel"></el-input> </el-form-item>
            </div>
          </div>
          <div class="setting-upgrade-wrap">
            <div class="setting-upgrade-title">請求先メールアドレス<span style="color:red">*</span></div>
            <div class="setting-upgrade-content">
              <el-form-item prop="email"><el-input v-model="form.email"></el-input> </el-form-item>
            </div>
          </div>
          <div class="setting-upgrade-wrap">
            <div class="setting-upgrade-title">代表取締役名<span style="color:red">*</span></div>
            <div class="setting-upgrade-content">
              <el-form-item prop="representative"><el-input v-model="form.representative"></el-input> </el-form-item>
            </div>
          </div>
          <div class="setting-upgrade-wrap">
            <div class="setting-upgrade-title">会社郵便番号<span style="color:red">*</span></div>
            <div class="setting-upgrade-content">
              <el-form-item prop="post_code"><el-input v-model="form.post_code"></el-input> </el-form-item>
            </div>
          </div>
          <div class="setting-upgrade-wrap">
            <div class="setting-upgrade-title">会社住所(番地まで)<span style="color:red">*</span></div>
            <div class="setting-upgrade-content">
              <el-form-item prop="address_1"><el-input v-model="form.address_1"></el-input> </el-form-item>
            </div>
          </div>
          <div class="setting-upgrade-wrap">
            <div class="setting-upgrade-title">会社住所(建物・ビル名)</div>
            <div class="setting-upgrade-content">
              <el-input v-model="form.address_2"></el-input>
            </div>
          </div>
        </div>

        <div class="setting-wrap upgrade" style="margin-bottom:60px">
          <div class="wrap-title">確認事項</div>
          <ol class="setting-upgrade-confirmation">
            <li v-if="form.payment == 0 || form.payment == 1 || form.payment == 7 || form.payment == 4">
              本契約は、契約期間が終了した時点で自動的に更新されます。更新時の契約内容は本契約と同一プランの6ヶ月契約となり、期間・料金ともに6ヶ月契約の内容に変更されます。更新を希望されない場合は、必ず契約更新日の前日までに管理画面より解約手続を行ってください。
            </li>
            <li v-else>本契約は、契約期間が終了した時点で自動的に更新されます。更新時の契約内容は本契約と同一プラン、同一契約期間となります。更新を希望されない場合は、必ず契約更新日の前日までに管理画面より解約手続を行ってください。</li>
            <li>プロモーションコードを利用された場合、契約自動更新後の料金にはプロモーション価格は適用されません。</li>
            <li>お申込み後、すぐにアップグレードが適用されます。</li>
            <li>お申込み後に弊社にて所定の審査を実施させていただきます。審査により、アップグレードの取消しを行いお客様との契約はお断りさせていただく場合がございます。</li>
            <li>
              本契約を締結されたアカウントは、他社・他部署への共有はお断りさせていただいております。他社・他部署へのアカウント共有が発覚した場合、超過数×契約期間月の追加料金をご請求させていただきます。
            </li>
            <li>領収書の発行は行っておりません。 振込の際のお客様控えをもって領収書に代えさせていただきます。</li>
            <li>上記の他、{{ siteName }} 利用規約およびプライバシーポリシーに同意していただきます。(利用規約をご覧の際は必ずブラウザのキャッシュをクリアして最新のものを閲覧ください。)</li>
            <br />
            <el-form-item prop="confirm">
              <el-checkbox class="setting-upgrade-checkbox" v-model="form.confirm">
                上記確認事項および
                <a :href=termsOfUseUrl target="_blank" style="color:#0095f6">利用規約</a>
                に同意します。
              </el-checkbox>
            </el-form-item>
          </ol>
          <div style="width: 100%; margin:20px 0px; display:flex; flex-flow:row; justify-content:center">
            <el-button type="primary" native-type="submit" :disabled="loading">
              <div class="flex-row">
                アップグレードを完了
                <div class="loader--mini" v-show="loading"></div>
              </div>
            </el-button>
          </div>
        </div>
      </el-form>

      <!-- createList dialog -->
      <el-dialog title="プロモーションコードを入力" :visible.sync="coupon_modal" width="420px" top="20vh">
        <el-form style="width:100%" @submit.native.prevent="activateCoupon">
          <div class="list-create">
            <div class="list-create-box">
              <div class="list-create-name">プロモーションコードを入力してください</div>
              <el-form-item prop="list_name">
                <el-input v-model="coupon_value" id="autoFocus"></el-input>
              </el-form-item>
            </div>
            <div class="list-create-footer">
              <el-button @click="coupon_modal = false">キャンセル</el-button>
              <el-button type="primary" native-type="submit">適用する</el-button>
            </div>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";

const root = process.env.VUE_APP_API;
const getUserDataAPI = root + "/api/auth/load_userdata";
const activateCouponAPI = root + "/api/upgrade/activate_coupon";
const upgradeAPI = root + "/api/upgrade/upgrade_purchase";
import {
  STARTER,
  MANAGER,
  PARTNER,
  PRO,
  ENTERPRISE,
} from '../../const/plan';

export default {
  name: "upgrade",
  components: {
    UserTokenSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    var validateConfirm = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("同意は必須です"));
      } else {
        callback();
      }
    };
    return {
      userdata: [],
      form: {
        payment: 6,
        payment_option: true,
        payment_method: 1,
        client_name: "",
        person_name: "",
        department: "",
        tel: "",
        email: "",
        representative: "",
        post_code: "",
        address_1: "",
        address_2: "",
        confirm: "",
        coupon_code: "",
      },
      price: {
        starter: {
          month1: "",
          month3: "",
          month6: 40000,
          month12: 30000,
          coupon_on: false,
        },
        manager: {
          month1: "",
          month3: "",
          month6: 125000,
          month12: 100000,
          coupon_on: false,
        },
        partner: {
          month1: "",
          month3: "",
          month6: 175000,
          month12: 150000,
          coupon_on: false,
        },
        pro: {
          month1: "",
          month3: "",
          month6: 350000,
          month12: 300000,
          coupon_on: false,
        },
        enterprise: {
          month12: 800000,
          month24: 700000,
          coupon_on: false,
        },
      },
      loading: false,
      rules_user: {
        client_name: [{ required: true, message: "企業名は必須です", trigger: "blur" }],
        person_name: [{ required: true, message: "担当者名は必須です", trigger: "blur" }],
        department: [{ required: true, message: "担当部署は必須です", trigger: "blur" }],
        tel: [
          { required: true, message: "電話番号は必須です", trigger: "blur" },
          {
            min: 9,
            message: "正しい電話番号を入力してください",
            trigger: "blur",
          },
        ],
      },
      rules_upgrade: {
        client_name: [{ required: true, message: "企業名は必須です", trigger: "blur" }],
        person_name: [{ required: true, message: "担当者名は必須です", trigger: "blur" }],
        department: [{ required: true, message: "担当部署は必須です", trigger: "blur" }],
        email: [
          {
            required: true,
            message: "メールアドレスは必須です",
            trigger: "blur",
          },
        ],
        tel: [{ required: true, message: "電話番号は必須です", trigger: "blur" }],
        representative: [
          {
            required: true,
            message: "代表取締役名は必須です",
            trigger: "blur",
          },
        ],
        post_code: [
          {
            required: true,
            message: "会社郵便番号は必須です",
            trigger: "blur",
          },
        ],
        address_1: [{ required: true, message: "会社住所は必須です", trigger: "blur" }],
        confirm: [{ validator: validateConfirm, trigger: "change" }],
      },
      coupon_modal: false,
      coupon_value: "",
      promotion_price: false,
      siteName: "REECH DATABASE",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
    activate_at() {
      return this.$store.state.activate_at;
    },
    activate_starter() {
      return STARTER;
    },
    activate_manager() {
      return MANAGER;
    },
    activate_partner() {
      return PARTNER;
    },
    activate_pro() {
      return PRO;
    },
    activate_enterprise() {
      return ENTERPRISE;
    },
    contract_price() {
      const contract_price =
        this.form.payment == 0
          ? this.price.manager.month1
          : this.form.payment == 1
          ? this.price.manager.month3
          : this.form.payment == 2
          ? this.price.manager.month6
          : this.form.payment == 3
          ? this.price.manager.month12          
          : this.form.payment == 140
          ? this.price.partner.month1
          : this.form.payment == 141
          ? this.price.partner.month3
          : this.form.payment == 142
          ? this.price.partner.month6
          : this.form.payment == 143
          ? this.price.partner.month12          
          : this.form.payment == 7
          ? this.price.pro.month1
          : this.form.payment == 4
          ? this.price.pro.month3
          : this.form.payment == 5
          ? this.price.pro.month6
          : this.form.payment == 6
          ? this.price.pro.month12
          : this.form.payment == 8
          ? this.price.enterprise.month12
          : this.form.payment == 9
          ? this.price.enterprise.month24
          : this.form.payment == 100
          ? this.price.starter.month1
          : this.form.payment == 101
          ? this.price.starter.month3
          : this.form.payment == 10
          ? this.price.starter.month6
          : this.form.payment == 11
          ? this.price.starter.month12
          : 0;
      return contract_price;
    },
    contract_period() {
      const contract_period =
        this.form.payment == 0
          ? 1
          : this.form.payment == 1
          ? 3
          : this.form.payment == 2
          ? 6
          : this.form.payment == 3
          ? 12
          : this.form.payment == 7
          ? 1
          : this.form.payment == 4
          ? 3
          : this.form.payment == 5
          ? 6
          : this.form.payment == 6
          ? 12
          : this.form.payment == 8
          ? 12
          : this.form.payment == 9
          ? 24
          : this.form.payment == 10
          ? 6
          : this.form.payment == 11
          ? 12
          : this.form.payment == 100
          ? 1
          : this.form.payment == 101
          ? 3
          : this.form.payment == 140
          ? 1
          : this.form.payment == 141
          ? 3
          : this.form.payment == 142
          ? 6
          : this.form.payment == 143
          ? 12
          : 0;
      return contract_period;
    },
    period_start() {
      const dt = new Date();
      const year = dt.getFullYear();
      const month = dt.getMonth() + 1;
      const date = dt.getDate();
      const period_start = year + "/" + month + "/" + date;
      return period_start;
    },
    period_end() {
      const dt = new Date();
      dt.setMonth(dt.getMonth() + this.contract_period);
      const year = dt.getFullYear();
      const month = dt.getMonth() + 1;
      const date = dt.getDate() - 1;
      const period_end = year + "/" + month + "/" + date;
      return period_end;
    },
    coupon_on() {
      if (this.form.payment == 10 && this.price.starter.month6 != 40000) return true;
      if (this.form.payment == 11 && this.price.starter.month12 != 30000) return true;      
      if (this.form.payment == 2 && this.price.manager.month6 != 125000) return true;
      if (this.form.payment == 3 && this.price.manager.month12 != 100000) return true;      
      if (this.form.payment == 142 && this.price.partner.month6 != 175000) return true;
      if (this.form.payment == 143 && this.price.partner.month12 != 150000) return true;      
      if (this.form.payment == 5 && this.price.pro.month6 != 350000) return true;
      if (this.form.payment == 6 && this.price.pro.month12 != 300000) return true;
      if (this.form.payment == 8 && this.price.enterprise.month12 != 800000) return true;
      if (this.form.payment == 9 && this.price.enterprise.month24 != 700000) return true;
      else return false;
    },
    show_service_plan_list() {
      return this.$store.state.service_plan_list.filter(e => { return e.show_plan_list === 1});
    },
    selected_plan() {      
      const plan_activate =
        this.form.payment >= 0 && this.form.payment <= 3
          ? 12
          : this.form.payment >= 140 && this.form.payment <= 143
          ? 14
          : this.form.payment >= 4 && this.form.payment <= 7
          ? 15
          : this.form.payment >= 8 && this.form.payment <= 9
          ? 17
          : this.form.payment >= 10 && this.form.payment <= 101
          ? 10
          : 0;
              
      return this.findServicePlanByActivate(plan_activate);
    }
  },
  created() {
    this.activateCheck();
  },
  mounted() {
    this.indexScroll();
    this.loadQuery();
    this.loadUserData();
    this.$store.dispatch("changeActive", "setting");
  },
  methods: {
    activateCheck() {
      if (this.activate == 12 || this.activate == 13 || this.activate == 15) {
        this.$router.push("/dashboard");
      }
    },
    indexScroll() {
      window.scroll({
        //画面を上部に移動
        top: 0,
        behavior: "instant",
      });
    },
    loadUserData() {
      this.axios
        .get(getUserDataAPI, {
          params: {
            token: this.token,
            user_token: this.user_token,
          },
        })
        .then((response) => {
          this.userdata = response.data;
          this.form.client_name = response.data.bill_client_name;
          this.form.department = response.data.bill_department;
          this.form.person_name = response.data.bill_person_name;
          this.form.tel = response.data.bill_tel;
          this.form.email = response.data.bill_email;
          this.form.representative = response.data.bill_representative;
          this.form.post_code = response.data.bill_post_code;
          this.form.address_1 = response.data.bill_address_1;
          this.form.address_2 = response.data.bill_address_2;
        });
    },
    loadQuery() {
      if (this.$route.query.payment == "pro") {
        this.form.payment = 6;
      } else if (this.$route.query.payment == "partner") {
        this.form.payment = 143;
      } else if (this.$route.query.payment == "manager") {
        this.form.payment = 3;
      } else if (this.$route.query.payment == "starter") {
        this.form.payment = 11;
      } else if (this.$route.query.payment == "enterprise") {
        this.form.payment = 9;
      }
    },
    loadUserDataCopy() {
      this.axios
        .get(getUserDataAPI, {
          params: {
            token: this.token,
            user_token: this.user_token,
          },
        })
        .then((response) => {
          this.form.client_name = response.data.client_name;
          this.form.department = response.data.department;
          this.form.person_name = response.data.person_name;
          this.form.tel = response.data.tel;
          this.form.email = response.data.email;
        });
    },
    activateCoupon() {
      var params = new URLSearchParams();
      params.append("coupon_code", this.coupon_value);
      params.append("token", this.token);
      this.axios.post(activateCouponAPI, params).then((response) => {
        if (response.data.status == "OK") {          
          this.price.starter.month6 = response.data.price.starter_6month;
          this.price.starter.month12 = response.data.price.starter_12month;
          this.price.manager.month6 = response.data.price.manager_6month;
          this.price.manager.month12 = response.data.price.manager_12month;
          this.price.partner.month6 = response.data.price.partner_6month;
          this.price.partner.month12 = response.data.price.partner_12month;
          this.price.pro.month6 = response.data.price.pro_6month;
          this.price.pro.month12 = response.data.price.pro_12month;
          this.form.coupon_code = this.coupon_value;
          if (response.data.price.starter_1month || 
              response.data.price.manager_1month || 
              response.data.price.partner_1month ||
              response.data.price.pro_1month) {
            this.price.starter.month1 = response.data.price.starter_1month;
            this.price.manager.month1 = response.data.price.manager_1month;
            this.price.partner.month1 = response.data.price.partner_1month;
            this.price.pro.month1 = response.data.price.pro_1month;
          }
          if (response.data.price.starter_3month || 
              response.data.price.manager_3month || 
              response.data.price.partner_3month || 
              response.data.price.pro_3month) {
            this.price.starter.month3 = response.data.price.starter_3month;
            this.price.manager.month3 = response.data.price.manager_3month;
            this.price.partner.month3 = response.data.price.partner_3month;
            this.price.pro.month3 = response.data.price.pro_3month;
          }
          this.coupon_value = "";
          this.coupon_modal = false;
          //プロモーション価格かどうかを判定
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "プロモーション価格が適用されました",
          });
        } else if (response.data.status == "NG") {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "プロモーションコードが有効ではありません",
          });
        }
      });
    },
    apply() {
      this.loading = true;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var params = new URLSearchParams();
          params.append("payment", this.form.payment);
          params.append("payment_method", this.form.payment_method);
          params.append("coupon_code", this.form.coupon_code);
          params.append("bill_client_name", this.form.client_name);
          params.append("bill_person_name", this.form.person_name);
          params.append("bill_department", this.form.department);
          params.append("bill_tel", this.form.tel);
          params.append("bill_email", this.form.email);
          params.append("bill_representative", this.form.representative);
          params.append("bill_post_code", this.form.post_code);
          params.append("bill_address_1", this.form.address_1);
          params.append("bill_address_2", this.form.address_2);
          params.append("token", this.token);
          this.axios.post(upgradeAPI, params).then(() => {
            this.$store.dispatch("getUserData", { token: this.token, user_token: this.user_token });
            this.$router.push("/setting");
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "プランをアップグレードしました",
            });
          });
        } else {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "全ての項目を入力してください",
          });
          this.loading = false;
        }
      });
    },
    findServicePlanByActivate(activate) {
      return this.show_service_plan_list.find(service_plan => service_plan.activate === activate);
    },
    updateSiteInfo({siteName, termsOfUseUrl}) {
      this.siteName = siteName;
      this.termsOfUseUrl = termsOfUseUrl;
    },
  },
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
  },
  watch: {
    $route() {
      this.loadActive();
    },
    coupon_modal() {
      if (this.coupon_modal == true) {
        setTimeout(() => {
          document.getElementById("autoFocus").focus();
        }, 200);
      }
    },
  },
};
</script>
